import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//http request 拦截器
axios.interceptors.request.use(
	config => {
		// 获取token
		const token = localStorage.getItem('sign') || '';
		if (token) {
			config.headers.authorization = token
		}
		// 设置参数格式
		// if (!config.headers['Content-Type']) {
		//     // config.headers = {
		//     //     'Content-Type': 'application/x-www-form-urlencoded',
		//     // };
		// }
		// 添加token到headers

		return config;
	},
	err => {
		return Promise.reject(err);
	}
);
axios.interceptors.response.use(
	response => {
		if (response.data.errorMessage === '尚未登录' || response.data.status === 401 || response.data.errorMessage == 1001) {
			
		}
		return response;
	},
	error => {
		// if (error.response) {
		//         switch (error.response.status) {
		//             case 401:
		//                 // 返回 401 清除token信息并跳转到登录页面
		//                 // window.localStorage.setItem("redirectUrl", window.location.href);
		//                 // window.location = "/loginRegister/phoneLogin";
		//         }
		// }
		return Promise.reject(error.response) // 返回接口返回的错误信息
	});
export {
	axios
}